export const createHash = () => ({ 
  update: () => ({}), 
  digest: () => '' 
});
export default {};
